import React from 'react'
import { updateAbilityFromToken } from './Authorization'
import { IAbilityInitializer } from './AbilityProvider'
import {useKeycloak} from "@nic-react/auth";

export const AbilityInitializer: React.FC<IAbilityInitializer> = (props) => {
  const { restrictions, onUpdate } = props
  const  {keycloak}  = useKeycloak();

  React.useEffect(() => {

    if (keycloak !== undefined && keycloak.authenticated) {
      // Aggiorniamo ability finalmente.


      const _ab = updateAbilityFromToken(restrictions, keycloak)
      //ability.update(rules);
      onUpdate(_ab)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak.authenticated, restrictions])

  return <>{props.children}</>
}
